import { Storage } from './Storage';
export class LocalStorage extends Storage {
    get(key) {
        const result = window.localStorage.getItem(key);
        return result === null ? undefined : result;
    }
    set(key, value) {
        window.localStorage.setItem(key, value);
    }
    remove(key) {
        window.localStorage.removeItem(key);
    }
    // Removes all keys from local storage that match a provided RegExp.
    removeRegExp(regexp) {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && regexp.test(key)) {
                localStorage.removeItem(key);
            }
        }
    }
}
//# sourceMappingURL=LocalStorage.js.map